var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.508789 2.03125V10.9687C0.508789 12.1875 1.4666 12.1812 1.4666 12.1812H1.56386C1.74953 12.1843 1.93225 12.1399 2.0914 12.0415L9.48279 7.49341C9.80992 7.29663 9.97791 6.89673 9.97791 6.49683C9.97791 6.09692 9.80992 5.69702 9.48279 5.50342L2.0914 0.955322C1.93225 0.856934 1.74953 0.8125 1.56386 0.8125H1.4666C1.4666 0.8125 0.508789 0.8125 0.508789 2.03125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.9bf579c6f1df7a5638ba20bd8320477a.svg";
export { ForwardRef as ReactComponent };